import React, { SyntheticEvent } from 'react';
import ReactTable, { RowInfo } from 'react-table';
import { TasksTableFilters } from '../../types';
import { createTableColumns } from './tableConfig';
import { Task, UserProfile } from '@trnsact/trnsact-shared-types';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import { CustomPagination } from '../../../Table/Pagination';
import { usePagination } from '../../../shared/Table/hooks';

interface Props {
  filteredTasks: Task[];
  tasksQueryKey: string;
  userProfile: UserProfile;
  isTableDataLoading: boolean;
  fetchTasks: () => Promise<any>;
  tableFilters: TasksTableFilters;
  onOpenCreateTaskModel: (taskId: string) => void;
}

export const TaskTable = ({
  fetchTasks,
  userProfile,
  filteredTasks,
  tasksQueryKey,
  isTableDataLoading,
  onOpenCreateTaskModel,
}: Props) => {
  const classes = useStyles();

  const paginationProps = usePagination(filteredTasks?.length);

  const columns = createTableColumns({
    fetchTasks,
    userProfile,
    tasksQueryKey,
    onOpenCreateTaskModel,
  });

  const handleRowClick = (event: SyntheticEvent, taskId: string) => {
    event.preventDefault();
    event.stopPropagation();
    onOpenCreateTaskModel(taskId);
  };

  return (
    <ReactTable<Task>
      getTrProps={(_: any, rowInfo: RowInfo | undefined) => ({
        style: { cursor: 'pointer' },
        onClick: (event: SyntheticEvent) => {
          if (rowInfo) handleRowClick(event, rowInfo.original.taskId!);
        },
      })}
      columns={columns}
      data={filteredTasks}
      showPaginationBottom
      loading={isTableDataLoading}
      loadingText={'Loading tasks'}
      PaginationComponent={CustomPagination}
      className={clsx('-highlight', classes.table)}
      noDataText={isTableDataLoading ? '' : 'There are no tasks'}
      {...paginationProps}
    />
  );
};

const useStyles = makeStyles({
  table: {
    minHeight: '30rem',

    '& .rt-thead': {
      borderBottom: 'solid 1px rgba(0, 0, 0, 0.05)',
    },

    '& .rt-tr': {
      margin: 0,
      minHeight: '4rem',
    },

    '& .rt-td': {
      margin: 0,
    },
  },
});
